<app-input-wrapper [label]="label" [control]="form">
  <div class="flex" [formGroup]="form">
    <input type="date" formControlName="startDate" [max]="maxStartDate" />
    <span>&ndash;</span>
    <input
      type="date"
      formControlName="endDate"
      [min]="minEndDate"
      [max]="max"
    />
  </div>
</app-input-wrapper>
